<template>
  <div class="candidate">
    <a-radio-group v-model="status" @change="getData()">
			<a-radio-button value="1">新报名({{statusCounts.created_num || 0}})</a-radio-button>
			<a-radio-button value="2">已录取({{statusCounts.employ_num || 0}})</a-radio-button>
			<a-radio-button value="3">已到岗({{statusCounts.entry_num || 0}})</a-radio-button>
			<a-radio-button value="5">已完成({{statusCounts.finished_num || 0}})</a-radio-button>
			<a-radio-button value="6,7,8">结束({{statusCounts.abort_num || 0}})</a-radio-button>
    </a-radio-group>
		<a-spin :spinning="loading">
			<div class="job-list">
				<a-card class="job-item" v-for="(item, index) in list" :key="index">
					<a-row type="flex" justify="space-between">
						<a-col class="left">
							<div class="info">
								<img class="avatar" :src="item.resume.photo_url || defaultAvatar" />
								<div>
									<p>
										<span class="name">{{ item.resume.name  }}</span>
										<span class="">报名兼职</span>
										<span style="color:#1989FF">{{ item.job_name }}</span>
									</p>
									<p>{{ item.gender_id == 1 ? '男':'女'}} {{item.resume.age}}岁 {{item.resume_mobile}} {{ item.resume.school_graduated }} </p>
									<p class="leave-word"> 留言：{{ item.suggestion || '' }} </p>
								</div>
							</div>
						</a-col>
						<a-col class="salary" v-if="status != 1 && item.employ">
							<p>薪资：{{item.employ.basic_salary_lower}}-{{item.employ.basic_salary_upper}}元 / {{ item.employ.basic_salary_period | basicSalaryPeriod}}</p>
							<p>提成：{{item.employ.bonus_value}}{{item.employ.bonus_type===2?'%':item.employ.bonus_type===3?'元/件':''}}
							<p>预计入职：{{item.employ.on_board_time}}</p>
						</a-col>
						<a-col class="center" v-if="item.user">
							<img class="avatar" :src="item.user.picture || defaultAvatar" />
							<div>
								<p>{{ item.user.name }}</p>
								<p class="phone">{{ item.user.tel }}</p>
							</div>
						</a-col>
					</a-row>
					<a-row class="sign-date" type="flex" justify="space-between">
						<a-col style="line-height:36px;" @click.native.stop="$refs.processModal.show(item)">{{ item.created_at }} 报名 <i class="el-icon-arrow-down"></i></a-col>
					</a-row>
				</a-card>
				<a-empty v-if="!list.length"/>
				<a-row type="flex" align="middle" justify="end" :style="{ padding: '30px 0' }">
					<Pagination ref="pagination" :total="total" @change="getData"></Pagination>
				</a-row>
			</div>
		</a-spin>
		<ProcessModal ref="processModal"></ProcessModal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Api from '@/api'
import ProcessModal from '../processModal'
import Pagination from "@/components/Pagination";

export default {
  name: "info",
  props: {
		company_id: {
			default: -1
		},
		job_id: {
			default: -1
		}
	},
	components: { ProcessModal, Pagination },
  data() {
    return {
			defaultAvatar: require('@/assets/avatar.png'),
			loading: true,
      status: '1',
			list: [],
			total: 0,
			pagination: undefined,
			statusCounts: {},
    }
  },
  computed: {
    ...mapState([ 'config' ]),
  },
	mounted() {
		this.pagination = this.$refs.pagination;
		this.getStatusCounts()
		this.getData()
	},
  methods: {
		getStatusCounts() {
			Api.post.partTimeStatusCounts({ company_id: this.company_id, job_id: this.job_id }).then( res => {
				this.statusCounts = res
			})
		},
    getData(pagination) {
			this.loading = true
			if (pagination) {
        let pager = { ...this.pagination };
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.pagination = pager;
      } else {
        this.pagination.current = 1;
      }
			let params = {
				job_company_id: this.company_id,
				job_id: this.job_id,
				status: this.status,
				page: this.pagination.current,
        limit: this.pagination.pageSize,
			}
			Api.post.partTimeOrderList(params).then( res =>{
				this.list = res.list
				this.total = res.total
				this.loading = false
			}).catch( err => {
				console.log(err);
				this.loading = false
			})
    },	
  },
};
</script>

<style lang="scss" scoped>
.candidate {
  padding: 10px;
  ::v-deep .ant-card-body {
    padding: 17px 20px;
  }
  .job-list {
		margin-top: 20px;
		.job-item {
			position: relative;
			font-size: 14px;
			margin-bottom: 20px;
			.left {
				display: flex;
				align-items: center;
				.info {
					display: flex;
					span {
						margin-right: 10px;
					}
					.leave-word {
						font-size: 12px;
						color: #AAA;
					}
				}
			}
			.salary {
				padding-left: 20px;
				color: #FC5646;
				border-left: 1px solid #EBEEF5;
			}
			.center {
				display: flex;
				// justify-content: center;
			}
			p {
				margin-bottom: 5px;
			}
			.right {
				.btn-item {
					margin: 0 20px;
					cursor: pointer;
					img {
						width: 40px;
						height: 40px;
						margin-bottom: 10px;
					}
				}
				.warning {
					position: absolute;
					font-size: 18px;
					top: -10px;
					right: -10px;
					cursor: pointer;
				}
			}
			.avatar {
				width: 40px;
				height: 40px;
				margin: 0 15px 0 0;
				border-radius: 50%;
			}
			.sign-date {
				margin-top: 15px;
				padding: 15px 30px 0 0;
				border-top: 1px solid #EBEEF5;
				font-size: 14px;
				color: #999999;
				cursor: pointer;
			}
		}
	}
}
</style>
